import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-04jurassic_verticalalign_center",
  "use": "icon-04jurassic_verticalalign_center-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-04jurassic_verticalalign_center\"><path d=\"M64 480h896v64H64z\" fill=\"#727272\" /><path d=\"M832 256v512H576V256z\" fill=\"#B3B3B3\" /><path d=\"M448 128v768H192V128z\" fill=\"#497CAD\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol